import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { joinProjectInbox, onProjectDashboardReconnect } from 'src/features/companyProjects/realtime/projectDashboardHub';
import { useProjectDashboardRealtimeStore } from 'src/features/companyProjects/realtime/projectDashboardRealtimeStore';
import { useFrontierAuth } from 'src/util/auth/useFrontierAuth';

/**
 * ProjectIntakeInboxHub
 *
 * - Joins the inbox SignalR group so the server can target the connection.
 * - On reconnect, refetches authoritative data (SignalR does not replay missed messages).
 * Realtime payloads are handled in {@link ProjectDashboardRealtimeBridge} and the Zustand store.
 */
export const ProjectIntakeInboxHub = () => {
  const queryClient = useQueryClient();
  const { hasLoaded, isAuthenticated } = useFrontierAuth();

  useEffect(() => {
    if (!hasLoaded || !isAuthenticated) {
      return;
    }

    const unsubscribeJoinInbox = joinProjectInbox();

    const unsubscribeReconnect = onProjectDashboardReconnect(() => {
      useProjectDashboardRealtimeStore.getState().reset();
      void queryClient.invalidateQueries({
        queryKey: ['projectIntakeInbox'],
        type: 'active'
      });
      void queryClient.invalidateQueries({
        queryKey: ['myAssignedProjectContainers'],
        type: 'active'
      });
      void queryClient.invalidateQueries({
        queryKey: ['projectIntakeDetail'],
        type: 'all'
      });
    });

    return () => {
      unsubscribeJoinInbox();
      unsubscribeReconnect();
    };
  }, [queryClient, hasLoaded, isAuthenticated]);

  return null;
};
